"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_hooks_1 = require("@apollo/react-hooks");
var date_fns_1 = require("date-fns");
var Cookies = __importStar(require("js-cookie"));
var react_1 = __importStar(require("react"));
var _1 = require(".");
var create_magic_link_1 = require("./create_magic_link");
exports.default = (function (_a) {
    var loadingAnimationPath = _a.loadingAnimationPath, token = _a.token, destination = _a.destination, email = _a.email, jwt = _a.jwt, rhash = _a.rhash, csUser = _a.csUser;
    var createFinalUrl = function (addQuery) {
        // destination looks like this: /account?offer=FREEBIE&bundleId=1641842069548
        // so we'll make it absolute, add additional query params, and return it as a string
        var e_1, _a;
        if (addQuery === void 0) { addQuery = {}; }
        // sometimes the marketing team does not start the destination urls with a /
        var slashedDestination = (destination === null || destination === void 0 ? void 0 : destination.startsWith('/')) ? destination : "/".concat(destination || 'account');
        var urlString = window.location.protocol + '//' + window.location.host + slashedDestination;
        var url = new URL(urlString);
        try {
            // add any provided query parameters
            for (var _b = __values(Object.entries(addQuery)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], val = _d[1];
                url.searchParams.set(key, val || '');
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return url.toString();
    };
    var _b = __read((0, react_hooks_1.useMutation)(create_magic_link_1.CREATE_MAGIC_LINK, {
        onError: function (err) {
            // if there was an error, we will allow the user to continue to their original destination
            // shopify will redirect them to the /account/login page with intact query parameters
            console.error('There was an error', err);
            window.location.href = createFinalUrl();
        },
        onCompleted: function (data) {
            // it is assumed magicLink.link is already the correct finalUrl
            window.location.href = data.magicLink.link;
        },
    }), 1), createMagicLink = _b[0];
    (0, react_1.useEffect)(function () {
        window.initLottie('loading-animation-container', loadingAnimationPath);
        // TODO: why is this here?
        if (!!jwt) {
            Cookies.set(_1.SUBLESS_JWT_COOKIE_NAME, { jwt: jwt, csUser: csUser }, { expires: (0, date_fns_1.addHours)(new Date(), 2) });
            window.location.href = createFinalUrl({ rhash: rhash });
            return;
        }
        // TODO: why is this here?
        if (!token) {
            window.location.href = createFinalUrl();
            return;
        }
        // start the magic link process
        createMagicLink({ variables: { token: token, destination: destination, email: email } });
    }, []);
    return (react_1.default.createElement("div", { className: 'grid-x margin-top-16 margin-bottom-16' },
        react_1.default.createElement("div", { className: 'cell small-12 large-4 large-offset-4' },
            react_1.default.createElement("div", { id: 'loading-animation-container', className: 'bg-very-light-pink padding-8' }))));
});
